import { z } from "zod";
import { Explanation, Translation, TranscriptLine, VocabNote, OptionKey } from "./model.ts";
export const Review = z.strictObject({
  questions: z.array(
    z.strictObject({
      id: z.uuid(),
      number: z.number().int(),
      part: z.number().int(),
      correct: OptionKey,
      chosen: OptionKey.nullable(),
      explanation: Explanation,
      translation: Translation,
      vocab: z.array(VocabNote),
    }),
  ),
  passage: z
    .strictObject({
      html: z.string().nullable(),
      translationVi: z.string().nullable(),
      transcript: z.array(TranscriptLine).nullable(),
      vocab: z.array(VocabNote),
    })
    .nullable(),
});
export type Review = z.infer<typeof Review>;
